export default __webpack_public_path__ + "static/images/exo-taxi-map-icon.png";